module.exports = __webpack_public_path__ + "img/arrow-down-primary.cec0646a.svg";